module.exports = __webpack_public_path__ + "img/carousel-secretary.312b55d9.png";